  <button class="mode-button left" [class.active]="currentMode === 'table'" (click)="setMode('table')">
    <i class="material-icons">grid_view</i>
    <span>Table View</span>
  </button>
  <button class="mode-button right" [class.active]="currentMode === 'list'" (click)="setMode('list')">
    <i class="material-icons">view_list</i>
    <span>List View</span>
  </button>